import styled from 'styled-components';

const ModalTitleWrapper = styled.div`
  .modal-title {
    font-size: 32px;
    line-height: 1.2;
  }
  .danger {
    color: #e72f23;
  }
  .description {
    font-size: 12px;
    font-style: italic;
    font-weight: normal !important;
  }
`;

export { ModalTitleWrapper };
